import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_COMBO_SHARE_CTA_BUTTON_TREATMENT_EXPERIMENT = defineFcm('combo_share_cta_button_treatment_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'psf promote_or_share combo page',
		description: 'Gates the combo share CTA button visual treatment experiment (5-arm button styling test)',
		import: false,
		template: {
			enabled: false,
			experimentName: 'combo_share_cta_button_treatment',
		},
		deprecated: 'FCM no longer in use — safe to delete after 2026-08-13',
	});
